import cx from "classnames";
import React from "react";

import { ProductStockStatus as StockStatus } from "@/mk2/apps/bazaar/schemas";
import { BZ_IN_STOCK } from "@/mk/autogenerated/translation";

import styles from "./ProductStockStatus.mscss";

interface OwnProps {
    className?: string;
    stockStatus: StockStatus;
    small?: boolean;
}

type Props = OwnProps;

const ProductStockStatus = React.memo<Props>(({ className, stockStatus, small = false }) =>
    stockStatus === StockStatus.IN_STOCK ? (
        <span
            className={cx(
                styles.ProductStockStatus,
                className,
                small && styles["ProductStockStatus--small"],
                !small && styles["ProductStockStatus--normal"],
            )}
        >
            {BZ_IN_STOCK}
        </span>
    ) : null,
);

ProductStockStatus.displayName = "ProductStockStatus";

export default ProductStockStatus;
